import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { getUnpaidReservations } from "../../Helper";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import useAppSelector from "../../hooks/useAppSelector";
import useTranslate from "../../hooks/useTranslate";
import { accountSelector, optionsSelector } from "../../selectors/Selectors";
import { fetchReservations } from "../../store/actions/account";
import { TReservation } from "../../store/types";
import PageContainer from "../PageContainer";

export const UnpaidReservationsBar = () => {
    const t = useTranslate();
    const dispatch = useAppDispatch();
    const { reservations, token: userToken } = useAppSelector(accountSelector);
    const unpaidReservations: TReservation[] | undefined = getUnpaidReservations(reservations);
    const showUnpaidReservationsBar = useAppSelector(optionsSelector).reservation?.show_unpaid_reservations_bar;

    useEffect(() => {
        if (userToken) {
            dispatch(fetchReservations(userToken));
        }
        // eslint-disable-next-line
    }, [dispatch, userToken]);

    if (!userToken || !unpaidReservations?.length || !showUnpaidReservationsBar) {
        return null;
    }

    return (
        <div className="u-bg-yellow" role="alert" aria-live="polite">
            <PageContainer minHeight={false} className="u-p-9">
                <p>
                    {t("book.unpaid_reservations.text")} <Link to="/my-pages">{t("book.my_pages")}</Link>
                </p>
            </PageContainer>
        </div>
    );
};
